import { useState } from "react";
import { FAQS } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3">
                <span className="font-heading text-sm font-black tracking-wide text-primary-500">06</span>
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-accent-700">Trust & FAQ</span>
              </div>
              <h2 className="editorial-title mt-2 text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
                关于海角，你想问的都在这
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                海角网是一处专门整理论坛热帖、天涯热帖与论坛爆料的轻杂志站。我们只做搬运与精选，不生产瓜，只帮你把讨论现场搬到眼前。
              </p>
              <div className="mt-6 flex flex-col gap-3 rounded-lg bg-secondary-50 p-5">
                {["纯免费阅读", "标注原串来源", "实时盯板更新"].map((t) => (
                  <div key={t} className="flex items-center gap-3 text-sm font-medium text-foreground-800">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                      <i className="ri-check-line text-xs" />
                    </span>
                    {t}
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={i * 40}>
                  <div
                    className={`overflow-hidden rounded-md border transition-colors ${
                      isOpen ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-50"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-bold leading-relaxed text-foreground-950 md:text-base">{f.q}</span>
                      <i
                        className={`${isOpen ? "ri-subtract-line text-primary-500" : "ri-add-line text-foreground-500"} shrink-0 text-lg transition-transform`}
                      />
                    </button>
                    {isOpen ? (
                      <p className="px-5 pb-5 text-sm leading-[1.9] text-foreground-600">{f.a}</p>
                    ) : null}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}